var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sidebarFilter" },
    [
      _c("p", { staticClass: "sidebarFilter__desc" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.trans("CONTENT_TYPE_TEXT")) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.contentFilterTypes, function (type, index) {
        return _c(
          "label",
          {
            key: index,
            staticClass:
              "sidebarFilter__wrapperCheckBox sidebarFilter__wrapperContentType",
          },
          [
            _c(
              "span",
              {
                staticClass: "sidebarFilter__checkBox",
                class: {
                  "sidebarFilter__checkBox--disabled": type.disabledClass,
                  "sidebarFilter__checkBox--selected": type.selectedFilter,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedContentTypes,
                      expression: "selectedContentTypes",
                    },
                  ],
                  ref: "checkbox",
                  refInFor: true,
                  staticClass: "customCheckboxInput",
                  attrs: {
                    "data-gtm": `sidebarFilter__contentType--option${index}`,
                    type: "checkbox",
                    disabled: type.disabledClass,
                    name: `sidebarFilter__contentType--option-${index}`,
                    multiple: true,
                  },
                  domProps: {
                    value: type.group,
                    checked: Array.isArray(_vm.selectedContentTypes)
                      ? _vm._i(_vm.selectedContentTypes, type.group) > -1
                      : _vm.selectedContentTypes,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.selectedContentTypes,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = type.group,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.selectedContentTypes = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.selectedContentTypes = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.selectedContentTypes = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "customCheckbox" }),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "sidebar__icon sidebar__icon--contentType",
                    attrs: { width: "24", height: "24", "aria-hidden": "true" },
                  },
                  [_c("use", { attrs: { href: `${type.icon}` } })]
                ),
                _vm._v(
                  "\n            " + _vm._s(type.contentTypeName) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "sidebarFilter__pill" }, [
              _vm._v("\n            " + _vm._s(type.count) + "\n        "),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }